import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25.145}
    height={25.146}
    {...props}
  >
    <defs>
      <style>{".cls-1{fill:#00446e}"}</style>
    </defs>
    <g
      id="Group_686"
      data-name="Group 686"
      transform="translate(-616.465 -562)"
    >
      <path
        id="Path_211"
        data-name="Path 211"
        className="cls-1"
        d="m121.465 213.87-10.265 6.915a1.135 1.135 0 0 1-1.153 0l-10.374-6.915a1.078 1.078 0 0 0-1.676.838v13.83a.99.99 0 0 0 1.048 1.048h23.05a.99.99 0 0 0 1.048-1.048v-13.725a1.12 1.12 0 0 0-1.676-.943z"
        transform="translate(518.469 357.56)"
      />
      <path
        id="Path_212"
        data-name="Path 212"
        className="cls-1"
        d="M197.716 28h-14.668A.99.99 0 0 0 182 29.048v6.81a1.293 1.293 0 0 0 .419.838l7.334 4.924a1.135 1.135 0 0 0 1.153 0l7.334-4.92a1.068 1.068 0 0 0 .524-.838v-6.81A.99.99 0 0 0 197.716 28zm-4.191 7.02h-2.619v2.619a.524.524 0 1 1-1.048 0V35.02h-2.619a.524.524 0 1 1 0-1.048h2.619v-2.619a.524.524 0 1 1 1.048 0v2.619h2.619a.524.524 0 1 1 0 1.048z"
        transform="translate(438.656 534)"
      />
    </g>
  </svg>
)

export default SvgComponent
